/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Okular_LicenseInputs */

const en_pc_alt_t_okular_license = /** @type {(inputs: Pc_Alt_T_Okular_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open source (GPL)`)
};

const zh_pc_alt_t_okular_license = /** @type {(inputs: Pc_Alt_T_Okular_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源（GPL）`)
};

/**
* | output |
* | --- |
* | "Open source (GPL)" |
*
* @param {Pc_Alt_T_Okular_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_okular_license = /** @type {((inputs?: Pc_Alt_T_Okular_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Okular_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_okular_license(inputs)
	return zh_pc_alt_t_okular_license(inputs)
});
export { pc_alt_t_okular_license as "pc.alt.t.okular.license" }